import {IListCategory, IListMenuItem} from './interfaces';

export const MAX_VISIBLE_ITEMS = 7;
export const EVENT_LIST_MENU_MOBILE_OPEN = 'event-list-menu-mobile-open';

/**
 * open mobil list menu from outside
 */
export const sendOpenMobileListMenuEvent = () => {
    document.dispatchEvent(new Event(EVENT_LIST_MENU_MOBILE_OPEN));
};

/**
 * menu data is received from SP 'as-is' and pasted on the page as JSON.
 * this function should group all menu elements by category, and perform other data fixes / preperations.
 */
export const prepareData = (data: IListMenuItem[]) => {

    if(!data) return [];

    const copy = JSON.parse(JSON.stringify(data));
    const map = new Map();

    for(let i=0; i<copy.length; i++){
        const item = copy[i];

        if(map.has(item.categoryName)){
            const category = map.get(item.categoryName) as IListCategory;
            category.linkItems.push(item);
            category.showReadMore = category.linkItems.length > MAX_VISIBLE_ITEMS;
            map.set(item.categoryName, category);
        }
        else{
            const category: IListCategory = {
                categoryName: item.categoryName,
                linkItems: [item],
                showReadMore: false,
                isOpened: true,
            };
            map.set(item.categoryName, category);
        }
    }

    return Array.from(map.values()) as unknown as IListCategory[];
};